import React, { useEffect, useState } from "react";
import Logo from "../../../assets/img/logo.png";
import EyeBlock from "../../../assets/img/eye_block.svg";
import EyeOpen from "../../../assets/img/eye_open.svg";
import CheckboxIcon from "../../../assets/img/check-icon.svg";
import Checkbox from "react-custom-checkbox";
import { theme } from "./theme";
import { ThemeProvider } from "@mui/system";
import api from "../../../config/api";
import { getUserEstablishment } from "../../../config/utils";
import Spinner from "react-bootstrap/Spinner";
import { isAdmin, isEstablishment } from "../../../config/auth";
import { getCategory } from "../../../config/utils";
import swal from "sweetalert";

function Login() {
  const [user, setUser] = useState({ email: "", password: "" });
  const [loadBtn, setLoadBtn] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const [message, setMessage] = useState("");
  const handleChange = (event) => {
    setUser((values) => ({
      ...values,
      [event.target.name]: event.target.value,
    }));
  };

  // function isMobileDevice() {
  //   return typeof window.orientation !== "undefined" || navigator.userAgent.indexOf("IEMobile") !== -1;
  // }

  // function verificationMobile() {
  //   const isMobile = isMobileDevice();

  //   if (isMobile) {
  //     return swal(
  //       "Usuário",
  //       "Reservei Dashboard desenvolvido para desktop, utilize-o usando a visualização desktop!, Obrigado :)",
  //       "error"
  //     );
  //   }
  //   return;
  // }

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoadBtn(true);
    await api.post("/login", user).then(async (res) => {
      if (res.data.success) {
        await getCategory();
        if (res.data.user.role === "client") {
          swal(
            "Usuário de aplicativo!",
            " Esse usuário é cadastrado para uso exclusivo do aplicativo, não é possível acessar o dashboard.",
            "error"
          );
          setLoadBtn(false);
          return;
        }

        localStorage.setItem("@Reservei:token", res.data.token);
        localStorage.setItem("@Reservei:userId", res.data.user._id);
        // console.log(JSON.stringify(res.data));
        //  Initialize establishment local storage
        const userEstablishment = await getUserEstablishment(res.data.user._id);
        userEstablishment[0] && localStorage.setItem("@Reservei:userEstablishment", userEstablishment[0]._id);
        // console.log("JSON.stringify(userEstablishment)");
        // console.log(JSON.stringify(userEstablishment[0].category.slug));
        userEstablishment[0]?.category &&
          localStorage.setItem("@Reservei:userCategory", userEstablishment[0].category._id);
        if (res.data.user.role === "admin") {
          document.location.href = "/dashboard";
        } else {
          document.location.href = "/dashboard-user";
        }
        setLoadBtn(false);
      } else {
        setMessage(res.data.message);
        setLoadBtn(false);
      }
    });
  };

  useEffect(() => {
    if (isAdmin()) {
      document.location.href = "/dashboard";
    } else if (isEstablishment()) {
      document.location.href = "/dashboard-user";
    }
  }, []);
  return (
    <ThemeProvider theme={theme}>
      <div className="container-fluid mb-5 mb-lg-0  h-100">
        <div className="row h-100">
          <div className="bg-img-login col-lg-7 d-flex justify-content-start align-items-end ">
            <div className="row m-0">
              <h1 className="title mb-3 text-white fz-34 ff-univanova-300">
                Bem-vindo ao <br />
                <span className="ff-univanova-bold">RESERVEI</span>
              </h1>
              <h2 className="subtitle mb-4 text-white fz-16 ff-univanova-300">Versão 1.0.5</h2>
            </div>
          </div>
          <div className="col-lg-5 mt-5 my-lg-auto">
            <form className="px-3 mb-5 mb-lg-0" onSubmit={handleLogin}>
              <div className="d-flex justify-content-center align-items-center mb-5">
                <img alt="" src={Logo} />
              </div>
              <div className="mb-4">
                <h2 className="d-flex justify-content-center ff-univanova-600 fz-24 text-cl-cyan">Iniciar sessão</h2>
              </div>
              <div className="">
                <h2 className="ff-univanova-regular fz-16 text-cl-cyan">Seu e-mail</h2>
                <input
                  onChange={(event) => handleChange(event)}
                  name="email"
                  value={user.email}
                  autoComplete="on"
                  type={"email"}
                  placeholder="Digite seu e-mail"
                  className="input-line form-control ff-univanova-regular fz-14 text-cl-auroMetal px-0"
                  required
                />
              </div>
              <div className="">
                <h2 className="ff-univanova-regular fz-16 text-cl-cyan">Sua senha</h2>
                <div className="eye-component d-flex">
                  <input
                    name="password"
                    onChange={(event) => handleChange(event)}
                    type={showPassword ? "text" : "password"}
                    placeholder="Digite sua senha"
                    className="password input-line form-control ff-univanova-regular fz-14 text-cl-auroMetal px-0 w-90"
                    required
                  />
                  <button onClick={() => setShowPassword(!showPassword)} type="button" className="btn-eye">
                    <img
                      alt=""
                      width={"24px"}
                      height={"24px"}
                      className=" w-auto"
                      src={showPassword ? EyeOpen : EyeBlock}
                    />
                  </button>
                </div>
              </div>
              <div style={{ marginBottom: "32px" }}>
                <a href="/esqueci-minha-senha" className="text-cl-azure fz-14 ff-univanova-regular">
                  Esqueci a minha senha
                </a>
              </div>
              <div style={{ marginBottom: "24px" }}>
                <button
                  type="submit"
                  className="w-100 h-100 btn bg-gradient-theme-blue text-white font-poppins py-2 fz-18 d-flex justify-content-center ff-univanova-medium"
                >
                  {loadBtn ? (
                    <Spinner animation="border" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </Spinner>
                  ) : (
                    "Fazer login"
                  )}
                </button>
                <h3 className="mt-2 text-cl-red fz-12 ff-univanova-regular errorMessage">{message}</h3>
              </div>
              <div className="d-flex align-items-center justify-content-between check-box">
                <Checkbox
                  icon={<img style={{ width: "20px", height: "20px" }} alt="" src={CheckboxIcon} />}
                  name="my-input"
                  checked={rememberMe}
                  onChange={() => setRememberMe(!rememberMe)}
                  borderColor="#6D777D"
                  style={{ cursor: "pointer", width: "24px", height: "24px" }}
                  labelStyle={{
                    marginLeft: 8,
                    userSelect: "none",
                    color: "#6D777D",
                    fontSize: "14px",
                  }}
                  label="Lembrar de mim"
                />
                <div className="d-flex align-items-center">
                  <span className="text-cl-auroMetal fz-14 ff-univanova">Não tem conta?</span>
                  <div className={`d-flex justify-content-end ms-3`}>
                    <button
                      onClick={() => (document.location.href = "/criar-conta")}
                      className="btn btn-white button-white-primary fz-16 px-4 ff-univanova-medium"
                      type="button"
                    >
                      Criar conta
                    </button>
                  </div>
                </div>
              </div>
            </form>
            <div className=" mt-3 d-flex justify-content-center">
              <a href="/privacy-policy" className="text-cl-azure fz-14 ff-univanova-regular">
                Política de Privacidade
              </a>
            </div>
          </div>
        </div>
      </div>
    </ThemeProvider>
  );
}

export default Login;
